<template>
  <CCard class="contactFeed pt-5">
    <CRow>
      <CCol sm="12">
        <header class="contactFeed__header d-flex justify-content-between">
          <h3 class="contactFeed__title font-weight-normal">
            {{ $t('campaign.detail.feed.title') }}
          </h3>
        </header>
      </CCol>
      <CCol sm="12">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </CCol>
      <CCol sm="12">
        <div class="contactFeed__body p-0 pr-3 mt-4">
          <div v-if="loading" class="d-flex flex-column justify-content-center align-items-center p-5 h-100">
            <CSpinner class="my-3" color="primary" />
          </div>
          <div v-else>
            <!-- TODO criar components -->
            <ul class="p-0 feed" v-if="feed.length">
              <li class="py-2 feed__groups" v-for="(group, index) in groupFeed" :key="index">
                <p class="feed__groupDate text-gray-base text-uppercase font-base">
                  {{ group[0].activityDate | formatDate }}
                </p>
                <ul class="feed__list px-0">
                  <li class="feed__listItem py-3 text-gray-600" v-for="(item, i) in group" :key="item.activityDate + i">
                    <div v-if="'NOTE_ADDED' == ACTIVITY_TYPES[item.idActivityType]" class="d-flex feed__note">
                      <div>
                        <CIcon name="note" :height="30" class="feed__icon mt-2 mr-3" viewBox="0 0 32 32" />
                      </div>
                      <div v-if="loadingNote" class="d-flex flex-column justify-content-center align-items-center w-100">
                        <CSpinner class="my-3" color="primary" />
                      </div>
                      <div v-else class="w-100">
                        <!-- {{ $t('campaign.detail.feed.wrote-note') }} -->
                        <p>Note:</p>
                        <div>
                          <CForm v-if="item.edit" class="contactFeed__form form mt-1" :class="{ 'form--view': !item.edit }">
                            <CTextarea :disabled="!item.edit" v-model="item.activityActionPayload.content" />
                          </CForm>
                          <p v-else class="text-gray-700" v-html="item.activityActionPayload.content"></p>
                          <p class="date">{{ item.activityDate | formatHour }}</p>
                          <div class="mt-3">
                            <CButton v-if="item.edit" @click="saveNote(item)" color="white" class="mr-2" v-html="'Save'" />
                            <CButton v-if="item.edit" @click="item.edit = false" color="white" class="mr-2" v-html="'Cancel'" />
                            <CButton v-if="!item.edit" @click="editNote(item)" color="white" class="mr-2">
                              <CIcon name="editFull" :height="15" class="feed__icon" viewBox="0 0 32 32" />
                            </CButton>
                            <CButton v-show="!item.edit" @click.stop="openDelete(item)" color="gray-200" class="position-relative">
                              <CIcon name="trash" :height="15" class="feed__icon" viewBox="0 0 32 32" />
                              <transition name="fade" v-if="item.statePopUpDelete">
                                <div class="dataTable__popUp popUp popUp--top" @click.stop.stop>
                                  <div class="popUp__body shadow-sm">
                                    <ConfirmationDelete
                                      :title="$t('campaign.detail.feed.text-delete')"
                                      :description="''"
                                      @confirm="deleteNote(item)"
                                      @cancel="closePopUp()"
                                    />
                                  </div>
                                </div>
                              </transition>
                            </CButton>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        'SMS_CAMPAIGN_PARTICIPATION' == ACTIVITY_TYPES[item.idActivityType] ||
                        'EMAIL_CAMPAIGN_PARTICIPATION' == ACTIVITY_TYPES[item.idActivityType]
                      "
                      class="d-flex feed__comunication"
                    >
                      <div>
                        <CIcon name="emailSent" :height="28" class="feed__listItem mt-2 mr-3" viewBox="0 0 32 32" />
                      </div>
                      <div>
                        <p class="text-gray-600">
                          {{ $t('campaign.detail.feed.was-sent') }}
                          {{ ACTIVITY_TYPE_NAMES[item.idActivityType] }}
                          <router-link
                            :to="{ name: 'campaignResult', params: { campaignId: item.activityActionPayload.campaignId } }"
                            class="text-gray-700 text-decoration"
                            >{{ item.name }}</router-link
                          >
                        </p>
                        <p class="date">{{ item.activityDate | formatHour }}</p>
                      </div>
                    </div>
                    <div
                      v-if="
                        'RECIPIENT_UNSUBSCRIBED_EMAIL' == ACTIVITY_TYPES[item.idActivityType] ||
                        'RECIPIENT_UNSUBSCRIBED_SMS' == ACTIVITY_TYPES[item.idActivityType] || 
                        'RECIPIENT_UNSUBSCRIBED_SPAM' == ACTIVITY_TYPES[item.idActivityType] ||
                        'RECIPIENT_UNSUBSCRIBED_HARD_BOUNCED' == ACTIVITY_TYPES[item.idActivityType]
                      "
                      class="d-flex feed__comunication"
                    >
                      <div>
                        <CIcon name="emailSent" :height="28" class="feed__listItem mt-2 mr-3" viewBox="0 0 32 32" />
                      </div>
                      <div>
                        <p class="text-gray-600">
                          {{ $t(`campaign.detail.feed.${ACTIVITY_TYPE_NAMES[item.idActivityType]}`) }}
                        </p>
                        <p class="date">{{ item.activityDate | formatHour }}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>

            <h5 v-else class="d-flex justify-content-center align-items-center text-gray-700 font-weight-normal" style="height: 100px">
              {{ $t('campaign.detail.feed.empty') }}
            </h5>
          </div>
        </div>
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import services from '@/services.js'
import ConfirmationDelete from '@/components/ConfirmationDelete'
import MenssageAlert from '@/components/MenssageAlert'
import { ACTIVITY_TYPES, ACTIVITY_TYPE_NAMES } from '../../constants'

export default {
  name: 'ContactFeed',
  components: {
    MenssageAlert,
    ConfirmationDelete,
  },
  props: {
    hasNewNote: {
      type: Number,
      require: false,
    },
  },
  data() {
    return {
      ACTIVITY_TYPES,
      ACTIVITY_TYPE_NAMES,
      loading: false,
      loadingNote: false,
      feed: [],
      feedCopy: [],
      messages: [],
      campaings: [],
    }
  },

  mounted() {
    this.$root.$on('update-close-popup', () => {
      this.closePopUp()
    })
  },

  beforeDestroy() {
    this.$root.$off('update-close-popup')
  },

  async created() {
    this.getfeed()
  },

  methods: {
    openDelete(item) {
      const indexInFeed = this.feed.findIndex((element) => element.activityDate == item.activityDate)
      this.feed[indexInFeed].statePopUpDelete = true
    },

    editNote(item) {
      const indexInFeed = this.feed.findIndex((element) => element.activityDate == item.activityDate)
      this.feed[indexInFeed].edit = !item.edit
    },

    deleteNote(item) {
      this.loadingNote = true
      this.messages = []

      services
        .recipientDeleteNote(this.$route.params.organizationId, this.$route.params.id, item.activityActionPayload.key)
        .then(() => {
          const indexInFeed = this.feed.findIndex((element) => element.activityDate == item.activityDate)

          this.feed.splice(indexInFeed, 1)

          this.messages.push({
            status: 'success',
            text: 'The note was deleted',
          })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
          this.feed = JSON.parse(JSON.stringify(this.feedCopy))
        })
        .finally(() => {
          this.loadingNote = false

          // setTimeout(() => {
          //   this.getfeed(false)
          // }, 2000)
        })
    },

    saveNote(item) {
      this.loadingNote = true
      this.messages = []

      services
        .recipientPathNote(this.$route.params.organizationId, this.$route.params.id, item.activityActionPayload.key, {
          content: item.activityActionPayload.content,
          userId: this.$store.state.auth.user.id,
        })
        .then(() => {
          const indexInFeed = this.feed.findIndex((element) => element.activityDate == item.activityDate)
          this.feed.splice(indexInFeed, 1)

          this.messages.push({
            status: 'success',
            text: 'The note was edited',
          })

          this.getfeed(false)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
          this.feed = JSON.parse(JSON.stringify(this.feedCopy))
        })
        .finally(() => {
          this.loadingNote = false
        })
    },

    // TODO apagar depois
    mock() {
      this.feed = [
        {
          activityFeedId: '8a71c7b6-2a07-481d-9c2b-d331e47ed6d7',
          recipientId: '75f9849f-64e9-4e9b-b0dc-bb347eecf3a4',
          organizationId: '1abc40a5-24eb-4180-8b31-bb6f046ea27e',
          idActivityType: 2,
          activityType: 'NOTE_ADDED',
          activityActionPayload: {
            key: '7e759a90-3502-46f9-83e7-bbc22837206b',
            _MetaData: {
              createdDateTime: '2021-10-21T17:26:52.37Z',
              updatedDateTime: null,
              createdBy: '9f84f975-e964-9b4e-b0dc-bb347eecf3a4',
              lastUpdatedBy: null,
            },
            content: 'hello world',
            deleted: false,
          },
          activityDate: '2021-10-21T17:26:52.371Z',
        },
        {
          activityFeedId: '7e01b6bc-02df-4f2e-a27d-4317f3cff520',
          recipientId: '75f9849f-64e9-4e9b-b0dc-bb347eecf3a4',
          organizationId: '1abc40a5-24eb-4180-8b31-bb6f046ea27e',
          idActivityType: 2,
          activityType: 'NOTE_ADDED',
          activityActionPayload: {
            key: '84b2da60-7aa4-4136-a905-0ee12632b108',
            _MetaData: {
              createdDateTime: '2021-10-21T17:03:27.343Z',
              updatedDateTime: null,
              createdBy: 'fa42563a-328f-11ec-8d3d-0242ac130003',
              lastUpdatedBy: null,
            },
            content: 'nota teste',
            deleted: false,
          },
          activityDate: '2021-10-21T17:03:27.344Z',
        },
      ].map((item) => {
        return {
          ...item,
          edit: false,
        }
      })
    },

    async getfeed(initLoading = true) {
      if (initLoading) {
        this.messages = []
        this.loading = true
      }

      try {
        const feed = await services.recipientFeed(this.$route.params.organizationId, this.$route.params.id)

        if (feed.data.data != null) {
          this.feed = feed.data.data.map((item) => {
            return {
              ...item,
              edit: false,
              statePopUpDelete: false,
            }
          })

          this.$store.dispatch('audience/updateAudienceFeed', JSON.parse(JSON.stringify(this.feed)))

          let organizationId = this.$route.params.organizationId
          let campaigns = feed.data.data.map((item) => {
            if (item.activityActionPayload?.campaignId) {
              return services.getCampaign(organizationId, item.activityActionPayload.campaignId)
            }
          })

          this.promiseCompaignFeed(campaigns)
        }
      } catch (error) {
        console.log('error', error)
        this.loading = false
        this.messages.push({
          status: 'danger',
          text: error.response.data.message,
        })
      }

      this.loading = false
    },

    promiseCompaignFeed(campaigns) {
      Promise.allSettled(campaigns)
        .then((item) => {
          this.campaings = item.filter((item) => item.status == 'fulfilled').map((elm) => elm.value.data.data)
        })
        .catch((error) => {
          console.log('error', error)
          throw new Error(error)
        })
        .finally(() => {
          this.feed.forEach((item, index) => {
            let campaingName = this.campaings.find((elm) => elm.campaignId === item.activityActionPayload.campaignId)?.name
            this.$set(this.feed[index], 'name', campaingName)
          })
          this.feedCopy = JSON.parse(JSON.stringify(this.feed))
          this.loading = false
        })
    },

    splitDayOfDate(activityDate) {
      return activityDate.split('T')[0]
    },

    regroupPerDay(feed) {
      const arr = feed.reduce((acc, cur) => {
        if (!acc[this.splitDayOfDate(cur.activityDate)]) {
          acc[this.splitDayOfDate(cur.activityDate)] = []
        }
        acc[this.splitDayOfDate(cur.activityDate)].push(cur)

        return acc
      }, [])

      return { ...arr }
    },

    orderPerHour(feed) {
      return feed.sort((data1, data2) => {
        if (data1.activityDate > data2.activityDate) {
          return -1
        }

        if (data1.activityDate < data2.activityDate) {
          return 1
        }

        return 0
      })
    },

    closePopUp() {
      this.feed.forEach((element) => {
        element.statePopUpDelete = false
      })
    },
  },

  computed: {
    newNote() {
      // this.getfeed(false)
      return this.hasNewNote
    },

    groupFeed() {
      return this.regroupPerDay(this.feedOrderPerHour)
    },

    feedOrderPerHour() {
      return this.orderPerHour(this.feed)
    },
  },

  watch: {
    hasNewNote() {
      this.getfeed()
    },
  },
}
</script>
<style lang="scss" scoped>
.contactFeed {
  &__body {
    overflow-x: auto;
    max-height: 500px;
  }

  p {
    padding: 0;
    margin: 0;
    font-size: $font-size-base + 0.13;

    &.date {
      font-size: $font-size-base;
    }
  }

  &__form.form {
    .form-group {
      display: initial;
    }

    textarea {
      padding: 1em 0;
      width: 100%;
    }
  }
}

.feed {
  &__listItem {
    &:last-child {
      .feed__comunication {
        &::before {
          display: none;
        }
      }
    }
  }
  &__comunication {
    position: relative;

    &::before {
      top: 95%;
      left: 13px;
      position: absolute;
      content: '';
      display: block;
      width: 1px;
      height: 70%;
      background: $gray-500;
    }
  }
}
</style>
